<style lang="scss">
</style>
<template>
  <div class="page">
    <div class="padded">
      Join a pool
    </div>
  </div>
</template>
<script>
import api from '../api';

export default {
  name: 'JoinPool',
  props: {
  },
  created() {
    // If user is logged in, try to join the pool
    if (this.$store.getters.isLoggedIn) {
      api.PoolParticipationOffer.destroy({params: {id: this.$route.params.participationVerification}})
        .then(pool => {
          // If user could join the pool, move to the pool page
          this.$store.commit('updateCachedPool', pool);
          this.$store.commit('clearParticipationVerification');
          return this.$router.replace({name: 'pool', params: {id: pool.id}});
        })
        .catch(err => {
          // If user couldn't join and is logged in, send to dashboard
          this.$store.dispatch('messages/setMessage', {key: 'dashboardErrors', message: err.response.data.errors});
          this.$store.commit('clearParticipationVerification');
          this.$router.replace({name: 'dashboard'});
        });
    } else {
      // If user isn't logged in, set the participationVerification and go to welcome
      this.$store.commit('setParticipationVerification', this.$route.params.participationVerification);
      this.$router.replace({name: 'welcome'});
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  }
};
</script>
